export default __webpack_public_path__ + "static/media/emoji.802e4e1c.png";